import React, { Component } from "react";
import PropTypes from "prop-types";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetRebateGroupsDTO from "../../../models/DTO/IGetRebateGroupsDTO";
import IGetSpiffGroupsDTO from "../../../models/DTO/IGetSpiffGroupsDTO";
import IOnCreateSpiffGroupDTO from "../../../models/DTO/IOnCreateSpiffGroupDTO";
import IOnGetRebateGroupsDTO from "../../../models/DTO/IOnGetRebateGroupsDTO";
import IOnGetSpiffGroupsDTO from "../../../models/DTO/IOnGetSpiffGroupsDTO";
import IOnUpdateSpiffGroupItemsDTO from "../../../models/DTO/IOnUpdateSpiffGroupItemsDTO";
import IOnUpdateSpiffGroupUsersDTO from "../../../models/DTO/IOnUpdateSpiffGroupUsersDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IRebate_Group from "../../../models/IRebate_Group";
import ISpiff from "../../../models/ISpiff";
import ISpiff_Group from "../../../models/ISpiff_Group";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import RebateGroupSidebar from "../Rebates/RebateGroupSidebar/RebateGroupSidebar";
import SpiffGroupRow from "./SpiffGroupRow/SpiffGroupRow";
import SpiffGroupSidebar from "./SpiffGroupSidebar/SpiffGroupSidebar";
import { Socket } from "socket.io-client";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    setActivityIndicator?: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
};

type State = {
    breadcrumbs: IBreadcrumbs[];
    resultsLoaded: boolean;
    spiffGroups: ISpiff_Group[];
};

class Spiff extends Component<Props, State> {
    readonly state: State = {
        breadcrumbs: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "SPIFF", url: "/business/spiff" },
        ],
        resultsLoaded: false,
        spiffGroups: [],
    };

    componentDidMount(): void {
        this.props.socket.on("onCreateSpiffGroup", this.onCreateSpiffGroup);
        this.props.socket.on("onGetSpiffGroups", this.onGetSpiffGroups);
        this.props.socket.on("onUpdateSpiffGroupUsers", this.onUpdateSpiffGroupUsers);
        this.props.socket.on("onUpdateSpiffGroupItems", this.onUpdateSpiffGroupItems);

        this.getSpiffGroups();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onCreateSpiffGroup", this.onCreateSpiffGroup);
        this.props.socket.removeListener("onGetSpiffGroups", this.onGetSpiffGroups);
        this.props.socket.removeListener("onUpdateSpiffGroupUsers", this.onUpdateSpiffGroupUsers);
        this.props.socket.removeListener("onUpdateSpiffGroupItems", this.onUpdateSpiffGroupItems);
    }

    onUpdateSpiffGroupItems = (data: IOnUpdateSpiffGroupItemsDTO) => {
        this.getSpiffGroups();
    };

    onUpdateSpiffGroupUsers = (data: IOnUpdateSpiffGroupUsersDTO) => {
        this.getSpiffGroups();
    };

    onCreateSpiffGroup = (data: IOnCreateSpiffGroupDTO) => {
        this.getSpiffGroups();
    };

    getSpiffGroups = () => {
        this.setState(
            {
                resultsLoaded: false,
            },
            () => {
                const payload: IGetSpiffGroupsDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                };

                this.props.socket.emit("getSpiffGroups", payload);
            }
        );
    };

    onGetSpiffGroups = (data: IOnGetSpiffGroupsDTO) => {
        this.setState({
            spiffGroups: data.spiffGroups,
            resultsLoaded: true,
        });
    };

    getSpiffGroupSidebar = (spiffGroup?: ISpiff_Group) => {
        return (
            <SpiffGroupSidebar
                userModel={this.props.userModel}
                socket={this.props.socket}
                supplierModel={this.props.supplierModel}
                toggleSidebar={this.props.toggleSidebar}
                spiffGroup={spiffGroup}
            />
        );
    };

    toggleSidebar = () => {
        this.props.toggleSidebar();
    };

    viewSidebar = (existingSpiffGroup?: ISpiff_Group) => {
        const spiffGroupSidebar = this.getSpiffGroupSidebar(existingSpiffGroup);
        this.props.setSidebarComponent(spiffGroupSidebar);
        this.props.toggleSidebar();
    };

    render() {
        return (
            <div className="Spiff">
                {/*<Breadcrumbs navItems={this.state.breadcrumbs} />*/}

                <div className="row">
                    <div className={"mt-3 col-12 d-flex align-items-center"}>
                        <OwTitle
                            className={"d-inline-flex me-2"}
                            title={"SPIFF"}
                            leftIconName={"fad fa-funnel-dollar"}
                            disableTranslation={true}
                        />
                        <div>
                            <OwButton
                                fn={() => {
                                    this.viewSidebar();
                                }}
                                leftIconClass={"far fa-plus"}
                                title={"add"}
                                className={"btn-warning"}
                            />
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-12 "}>
                        <table className={"table table-dark table-striped"}>
                            {this.state.spiffGroups
                                ? this.state.spiffGroups.map((group, index) => {
                                      return (
                                          <SpiffGroupRow
                                              key={group.guid}
                                              index={index}
                                              socket={this.props.socket}
                                              spiffGroup={group}
                                              userModel={this.props.userModel}
                                              supplierModel={this.props.supplierModel}
                                              editGroupSidebarFn={this.viewSidebar}
                                          />
                                      );
                                  })
                                : null}
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Spiff;
